import DraigRegular from "./fonts/Draig-Regular.otf";
import DraigBold from "./fonts/Draig-Bold.otf";
import QuatroRegular from "./fonts/Quatro-Slab-Regular.ttf";
import GoodHeadlineRegular from "./fonts/FFGoodHeadline-Regular.otf";

import { createTheme } from "@mui/material/styles";

export function createAppTheme(mode = "light") {
    const isDark = mode === "dark";

    return createTheme({
        typography: {
            fontFamily: ['"Open Sans"', "QuatroRegular", "Roboto"].join(","),
            h1: {
                fontFamily: "DraigRegular",
            },
            h2: {
                fontFamily: "DraigRegular",
            },
            h3: {
                fontFamily: "DraigRegular",
            },
            h4: {
                fontFamily: "DraigRegular",
            },
            h5: {
                fontFamily: "DraigRegular",
                fontSize: "30px",
            },
            h6: {
                fontFamily: "DraigRegular",
                fontSize: "22px",
            },
            button: {
                fontFamily: "DraigRegular",
            },
            body1: {
                fontFamily: "QuatroRegular",
            },
            bodyBold: {
                fontFamily: "QuatroRegular",
            },
        },
        components: {
            MuiButton: {
                variants: [
                    {
                        props: { variant: "contained", color: "primary" },
                        style: {
                            color: "#ffffff",
                            ...(isDark && {
                                backgroundColor: "#008035",
                                "&:hover": {
                                    backgroundColor: "#00752f",
                                },
                            }),
                        },
                    },
                ],
            },
            MuiCssBaseline: {
                styleOverrides: `
        :root {
          color-scheme: ${isDark ? "dark" : "light"};
        }
        @font-face {
          font-family: 'DraigRegular';
          font-style: normal;
          font-weight: 600;
          font-display: swap;
          src: local('Draig-Regular'), url(${DraigRegular}) format('opentype');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC,
                         U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
        @font-face {
          font-family: 'DraigBold';
          font-style: normal;
          font-weight: 600;
          font-display: swap;
          src: local('Draig-Bold'), url(${DraigBold}) format('opentype');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC,
                         U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
        @font-face {
          font-family: 'QuatroRegular';
          font-style: normal;
          font-weight: 600;
          font-display: swap;
          src: local('Quatro-Slab-Regular'), url(${QuatroRegular}) format('truetype');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC,
                         U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
        @font-face {
          font-family: 'GoodHeadlineRegular';
          font-style: normal;
          font-weight: 600;
          font-display: swap;
          src: local('FFGoodHeadline-Regular'), url(${GoodHeadlineRegular}) format('opentype');
          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC,
                         U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
            },
        },
        palette: {
            mode: isDark ? "dark" : "light",
            primary: {
                main: isDark ? "rgb(31, 184, 94)" : "rgb(0, 149, 61)",
            },
            secondary: {
                main: "rgb(244, 36, 29)",
            },
            background: isDark
                ? {
                      default: "#101512",
                      paper: "#19201c",
                      subtle: "#202923",
                      media: "#242d27",
                  }
                : {
                      default: "#f4f6f4",
                      paper: "#ffffff",
                      subtle: "#f8faf8",
                      media: "#eef1ee",
                  },
        },
    });
}

const theme = createAppTheme();

export default theme;
